import { createContext, useState, useEffect, useContext } from "react";
import { db } from "../firebase";
import { doc, getDoc, collection, getDocs, query, where} from 'firebase/firestore'

export const FeaturedContext = createContext();
export const useFeaturedContext = ()=>{
    return useContext(FeaturedContext)
}

export const FeaturedProvider = ({children})=>{
    const [state, setState] = useState();
    const fetchDocs = async()=>{
        const featuredRef1 = doc(db, "featuredProjects", "project1")
        const featuredRef2 = doc(db, "featuredProjects", "project2")
        const featuredRef3 = doc(db, "featuredProjects", "project3")
        const ref1 = await getDoc(featuredRef1)
        const ref2 = await getDoc(featuredRef2)
        const ref3 = await getDoc(featuredRef3)
        setState([ref1.data(), ref2.data(), ref3.data()]) 
        
    }
    useEffect(()=>{
        fetchDocs()
    }, [])

    return <FeaturedContext.Provider value={state}>
        {children}
    </FeaturedContext.Provider>
}